import axios from "axios";

const OrganizationService = {

    getAll: async function (filters) {
        try {
            const response = await axios.get(process.env.VUE_APP_SERVER_URL + '/api/v1/organizations?'+filters)
            return response.data.data;
        } catch (e) {
            console.log(e.message);
            return {
                organizations: null,
                error: e,
                message: "An error occurred while connecting to server"
            }
        }
    },

    getOne: async function (organizationId) {
        try {
            const response = await axios.get(process.env.VUE_APP_SERVER_URL + `/api/v1/organizations/${organizationId}`)
            return response.data.data;
        } catch (e) {
            console.log(e.message);
            return {
                organization: null,
                error: e,
                message: "An error occurred while connecting to server"
            }
        }
    },

    create: async function (params) {
        try {
            const response = await axios.post(process.env.VUE_APP_SERVER_URL + '/api/v1/organizations/', params)
            return response.data.data;
        } catch (e) {
            console.log(e);
            return {
                organization: null,
                error: e,
                message: "An error occurred while connecting to server"
            }
        }
    },

    update: async function (organizationId, params) {
        try {
            const response = await axios.put(process.env.VUE_APP_SERVER_URL + '/api/v1/organizations/' + organizationId, params)
            return response.data.data;
        } catch (e) {
            console.log(e.message);
            return {
                organization: null,
                error: e,
                message: "An error occurred while connecting to server"
            }
        }
    },

    updateConfig: async function (optionId, params) {
        try {
            const response = await axios.put(process.env.VUE_APP_SERVER_URL + '/api/v1/organizations/configs/' + optionId, params)
            return response.data.data;
        } catch (e) {
            console.log(e.message);
            return {
                option: null,
                error: e,
                message: "An error occurred while connecting to server"
            }
        }
    },

    updateAdminInvite: async function (params) {
        try {
            const response = await axios.put(process.env.VUE_APP_SERVER_URL + '/api/v1/administrators', params)
            return response.data.data;
        } catch (e) {
            console.log(e.message);
            return {
                option: null,
                error: e,
                message: "An error occurred while connecting to server"
            }
        }
    },

    deleteOrganization: async function (organizationId) {
        if (confirm("Are you sure you want to delete this organization?.")) {
            try {
                const response = await axios.delete(process.env.VUE_APP_SERVER_URL + `/api/v1/organizations/${organizationId}`)
                return response.data.data.message
            } catch (e) {
                console.log(e.message);
                return {
                    organization: null,
                    error: e,
                    message: "An error occurred while connecting to server"
                }
            }
        }
    },

};

export default OrganizationService;